const regex = {
  name: /^[a-zA-Z\s]*$/,
  // eslint-disable-next-line no-useless-escape
  email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  atLeastOneLetter: /[a-z]+/,
  atLeastOneUpperCase: /[A-Z]+/,
  atLeastOneDigit: /\d/,
  phone: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
};

export default regex;
